// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import { NotificationContainer } from "react-notifications";

import { store } from './redux/store';
import App from './App';

import './styles/custom.css';
import './styles/files.css';


ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <div>
                <App />
                <NotificationContainer/>
            </div>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/